import { render, staticRenderFns } from "./ModeratorTheme.vue?vue&type=template&id=854b61c6&scoped=true&"
import script from "./ModeratorTheme.vue?vue&type=script&lang=js&"
export * from "./ModeratorTheme.vue?vue&type=script&lang=js&"
import style0 from "./ModeratorTheme.vue?vue&type=style&index=0&id=854b61c6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "854b61c6",
  null
  
)

export default component.exports